import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import SeccionCabecera from "./seccion-cabecera-filtro";
import BloqueEstadistica from "../vista-regiones/bloque-estadisticas";
import SiniaCustomChart from "../../components/charts/sinia-custom-chart.component";
import { DataService } from "../../services/data.service";
import ChartUtils from "../../commons/chart-utils.module";
import IndicadoresAmbientales from "../../commons/indicadores.module";
import Ubigeo from "../../commons/ubigeo.module";
import LayersUtils from "./LayersUtils";
import StringUtils from "../../commons/string-utils.module";
import "./index.scss";

const DEFAULT_REGION_CODE = "00";
const DEFAULT_TEMATICA_CODE = "04";
class VistaTematicasAmbientales extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    VistaTematicasAmbientales.instanceCount++;
    let me = this;
    me.instanceId = VistaTematicasAmbientales.instanceCount;
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    this.state = {
      ubigeo: me.getCodigoRegionInicial(),
      marco: me.getCodigoTematicaInicial(),
      periodo: 2019,
      data_documento: [],
      data_norma: [],
      indicadores_store: [],
      indicadores_store_info: [],
      col_size_default: 6,
      showLayer: true,
      dataLayer: [],
      listLayer: [],
      dataLegend: [],
      showLegend: false,
      md_col_size: 6,
      showMenuLeft: true,
      activeTab: "1",
      currentItem: {},
      data_estadistica: [],
      availableStore: false
    };
    this.onChangeUbigeo = this.onChangeUbigeo.bind(this);
    this.onChangeMarco = this.onChangeMarco.bind(this);
    this.onChangeColSize = this.onChangeColSize.bind(this);
    this.handleClickLayerToogle = this.handleClickLayerToogle.bind(this);
    this.handleClickLayer = this.handleClickLayer.bind(this);
    this.handleClickLayerLegend = this.handleClickLayerLegend.bind(this);
    this.handleClickMenuLeft = this.handleClickMenuLeft.bind(this);
  }
  componentDidMount() {
    let me = this;
    me.mounted = true;
    IndicadoresAmbientales.formatRawData(function(indicadores) {
      me.setState({ marco: DEFAULT_TEMATICA_CODE,ubigeo:DEFAULT_REGION_CODE,availableStore:true });
    });
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }
  getMapLegendId() {
    return "map-tematica-legend-" + this.instanceId;
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoRegionInicial() {
    return (
      Ubigeo.getCodigoRegion(this.urlParams.region || "") || DEFAULT_REGION_CODE
    );
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoTematicaInicial() {
    return this.urlParams.tematica || DEFAULT_TEMATICA_CODE;
  }
  /**
   *
   * @param {Array} marco_indicadores
   */
  crearReferencias(marco_indicadores) {
    let me = this;
    if (marco_indicadores.length > 0) {
      marco_indicadores.forEach((item) => {
        me["ref" + item.id] = React.createRef();
      });
    }
  }
  handleClickLayerLegend(e) {
    e.preventDefault();
    let isVisible = this.state.showLegend;
    isVisible = !isVisible;
    this.setState({
      showLegend: isVisible,
    });
  }
  handleClickMenuLeft(e) {
    e.preventDefault();
    let isVisible = this.state.showMenuLeft;
    isVisible = !isVisible;
    this.setState({
      showLegend: !isVisible,
      showMenuLeft: isVisible,
      md_col_size: isVisible ? 6 : 12,
    });
  }
  /**
   *
   * @param {Array} ubigeo
   */
  onChangeUbigeo(ubigeo) {
    let me = this;
    me.setState({ ubigeo: ubigeo });
  }
  /**
   *
   * @param {String} marco
   */
  onChangeMarco(marco) {
    let me = this;
    me.setState({ marco: marco });
  }
  /**
   *
   * @param {Array} periodo
   */
  onChangePeriodo(periodo) {
  }
  /**
   *
   * @param {Array} marco_indicadores
   */
  onLoadingDataRemote(item) {
    var me = this;
    me.cargarDatos(item.id);
  }
  /**
   *
   * @param {string} idIndicador
   * @param {RefObject} referencia
   */
  renderChart(idIndicador, type = "bar") {
    let titleTpl = `Lima : ${IndicadoresAmbientales.getNombre(idIndicador)}`;
    return (
      <SiniaCustomChart
        exportable={true}
        chartType={type}
        titleTpl={titleTpl}
        yAxeTitle={IndicadoresAmbientales.getUnidad(idIndicador)}
        seriesLabel={IndicadoresAmbientales.getUnidad(idIndicador)}
        xAxeTitle="Años"
        source={`Fuente: ${IndicadoresAmbientales.getFuenteAbrev(idIndicador)}`}
        ref={this["ref" + idIndicador]}
      />
    );
  }
  /**
   *
   * @param {Int} idIndicador
   */
  cargarDatos(idIndicador) {
    var me = this,
      props = me.state;
    let serie = IndicadoresAmbientales.getSerie(idIndicador, props.ubigeo);
    if (serie) {
      DataService.getData(
        {
          query: "SNA08",
          ubigeo: props.ubigeo,
          marco: props.marco,
          serie: serie,
        },
        function(data) {
          if (me.mounted) {
            if (
              data.SNA08.data &&
              data.SNA08.data[0] &&
              data.SNA08.data[0].valor
            ) {
              let castedData = ChartUtils.formatYearlyDataForChart(
                data.SNA08.data
              );
              let lastData = ChartUtils.lastDataForChart(data.SNA08.data);
              me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
              lastData.id = idIndicador;
              lastData.data = data.SNA08.data;
              me.actualizarDatosWidget(lastData);
            } else {
              let castedData = ChartUtils.formatYearlyDataForChart([]);
              let lastData = ChartUtils.lastDataForChart([]);
              me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
              lastData.id = idIndicador;
              lastData.data = [];
              me.actualizarDatosWidget(lastData);
            }
          }
        }
      );
    } else {
      let castedData = ChartUtils.formatYearlyDataForChart([]);
      let lastData = ChartUtils.lastDataForChart([]);
      me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
      lastData.id = idIndicador;
      me.actualizarDatosWidget(lastData);
    }
  }
  getChart(idIndicador) {
    return this["ref" + idIndicador].current;
  }
  /**
   *
   * @param {SiniaCustomChart} chart
   * @param {object} datos
   * @param {array} data.valores
   * @param {array} data.categorias
   */
  actualizarDatosDeGrafico(chart, datos) {
    if (chart && chart.actualizarDatos) {
      chart.actualizarDatos(datos.valores, datos.categorias, {
        region: Ubigeo.getNombreRegion(this.state.ubigeo),
        anioInicio: datos.anioInicio,
        anioFin: datos.anioFin,
        unidad: "Hectareas",
      });
    }
  }
  /**
   *
   * @param {Object} chart
   * @param {Array} datos
   */
  actualizarDatosWidget(data) {
    let me = this;
    let new_indicadores_info = [];
    if (me.state.indicadores_store_info.length > 0) {
      me.state.indicadores_store_info.forEach(function(item, i) {
        if (item.id !== data.id) {
          new_indicadores_info.push(item);
        } else {
          let newitem = Object.assign({}, item);
          newitem.value = data.LastValor;
          newitem.periodo = data.LastPeriodo;
          new_indicadores_info.push(newitem);
        }
      });
      me.setState({
        indicadores_store_info: new_indicadores_info,
        data_estadistica: data.data,
      });
    }
  }
  resetDatosWidget() {
    let me = this;
    let new_indicadores_info = [];
    if (me.state.indicadores_store_info.length > 0) {
      me.state.indicadores_store_info.forEach(function(item, i) {
        let newitem = Object.assign({}, item);
        newitem.value = "";
        newitem.periodo = "";
        new_indicadores_info.push(newitem);
      });
      me.setState({
        indicadores_store_info: new_indicadores_info,
      });
    }
  }
  onChangeColSize(e, size) {
    e.preventDefault();
    let me = this;
    this.setState({ col_size_default: size }, () => me.onChangeChartSize());
  }
  onChangeChartSize() {
    if (window.xchart && window.xchart.charts.length > 0) {
      window.xchart.charts.forEach(function(p, k) {
        if (p) p.reflow();
      });
    }
  }
  handleClickLayerToogle(e) {
    e.preventDefault();
    let isVisible = this.state.showLayer;
    isVisible = !isVisible;
    this.setState({
      showLayer: isVisible,
    });
  }
  handleClickLayer(event) {
    let me = this;
    let dataLayer = [
      {
        url: event.target.attributes.getNamedItem("url").value,
        visible:
          event.target.attributes.getNamedItem("visible").value === "true",
        layerName: event.target.attributes.getNamedItem("layer").value,
        type: event.target.attributes.getNamedItem("layertype").value,
        link: event.target.attributes.getNamedItem("link").value,
        label: event.target.attributes.getNamedItem("label").value,
        fuente: event.target.attributes.getNamedItem("fuente").value,
        id: event.target.id,
        checked: event.target.checked,
        init: false,
      },
    ];
    let new_store = [];
    let found = false;
    me.state.dataLegend.forEach((item) => {
      if (item.id == event.target.id) {
        new_store.push(event);
        found = true;
      } else {
        new_store.push(item);
      }
    });
    if (!found) {
      new_store.push(dataLayer[0]);
    }
    this.setState({
      dataLayer: dataLayer,
      dataLegend: new_store,
    });
  }
  loadLayerMap(marco) {
    let me = this;
    LayersUtils.getLayers(marco, function(data) {
      if (data.child) {
        me.setState({
          listLayer: data.child,
          dataLegend: [],
        });
      } else {
        me.setState({
          listLayer: [],
          dataLegend: [],
        });
      }
    });
  }
  render() {
    let me = this;
    const {
      indicadores_store,
      indicadores_store_info,
      ubigeo,
      data_norma,
      marco,
      data_documento,
      col_size_default,
      showLayer,
      dataLayer,
      listLayer,
      showLegend,
      dataLegend,
      showMenuLeft,
      md_col_size,
      activeTab,
      currentItem,
      data_estadistica,
      availableStore
    } = this.state;
    let instanceLegendMap = me.getMapLegendId();
    return (
      <div>
        <Row>
          <Col>
            <Card>
            <CardHeader>
                <Row>
                  <Col>
                    <div>
                      <h5>Estadística Ambiental</h5>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <SeccionCabecera
          scope={me}
          ubigeo={ubigeo}
          marco={marco}
          onChangeMarco={this.onChangeMarco}
          onChangeUbigeo={this.onChangeUbigeo}
        />
        <BloqueEstadistica 
           availableStore={availableStore}
            idRegion={ubigeo}
            idTematica={marco} />
      </div>
    );
  }
}

export default VistaTematicasAmbientales;
